// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4957":"e808874468a48ae9","5158":"7e7ca555d3c3f6df","6874":"c015b17d7245d1e6","7092":"07ffc00392e9ced4","7807":"b3204816792a608a","8245":"51b780f09da4d7e1"}[chunkId] + ".js";
};